/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClinicDocType } from './ClinicDocType';
import {
    ClinicDocTypeFromJSON,
    ClinicDocTypeFromJSONTyped,
    ClinicDocTypeToJSON,
} from './ClinicDocType';
import type { FileSchemaOut } from './FileSchemaOut';
import {
    FileSchemaOutFromJSON,
    FileSchemaOutFromJSONTyped,
    FileSchemaOutToJSON,
} from './FileSchemaOut';

/**
 * 
 * @export
 * @interface ClinicApplicationDocsOut
 */
export interface ClinicApplicationDocsOut {
    /**
     * 
     * @type {string}
     * @memberof ClinicApplicationDocsOut
     */
    id?: string;
    /**
     * 
     * @type {FileSchemaOut}
     * @memberof ClinicApplicationDocsOut
     */
    privateFileId?: FileSchemaOut;
    /**
     * 
     * @type {ClinicDocType}
     * @memberof ClinicApplicationDocsOut
     */
    docType?: ClinicDocType;
}

/**
 * Check if a given object implements the ClinicApplicationDocsOut interface.
 */
export function instanceOfClinicApplicationDocsOut(value: object): boolean {
    return true;
}

export function ClinicApplicationDocsOutFromJSON(json: any): ClinicApplicationDocsOut {
    return ClinicApplicationDocsOutFromJSONTyped(json, false);
}

export function ClinicApplicationDocsOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicApplicationDocsOut {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'privateFileId': json['private_file_id'] == null ? undefined : FileSchemaOutFromJSON(json['private_file_id']),
        'docType': json['doc_type'] == null ? undefined : ClinicDocTypeFromJSON(json['doc_type']),
    };
}

export function ClinicApplicationDocsOutToJSON(value?: ClinicApplicationDocsOut | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'private_file_id': FileSchemaOutToJSON(value['privateFileId']),
        'doc_type': ClinicDocTypeToJSON(value['docType']),
    };
}

